import { FC } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icon, IconColor, IconSize, IconTypes } from '@app/ui'
import { useBrandConfig } from '@app/hooks/useBrandConfig'

export default function InstallPrompt() {
  return (
    <div>InstallPrompt</div>
  )
}

interface InstallComandProps {
    installApp: () => void,
  }

export const InstallPromptAndroid: FC<InstallComandProps>  =({ installApp })=>{
  const { t } = useTranslation()
  const { appTitle } = useBrandConfig()

  return (
    <InstallCard>
      <InstallCardLeft>
        <AppIconWrapper>
          <AppIconImg src="/assets/branding/logotype-entry-x.png" alt={t('userEntry.appIcon')} />
        </AppIconWrapper>
        <InstallCardText>
          <AppName>{appTitle}</AppName>
          <AppTagline>{t('login.poweringTipster')}</AppTagline>
        </InstallCardText>
      </InstallCardLeft>
      <InstallButton onClick={installApp}>
        {t('inapp-installer')}
      </InstallButton>
    </InstallCard>
  )
}

export const InstallPromptIos: FC<InstallComandProps> =({ installApp })=>{
  const { t } = useTranslation()
  const { appTitle } = useBrandConfig()

  return (
    <InstallCard>
      <InstallCardLeft>
        <IosImageIcon src="/assets/branding/logotype-entry-x.png" alt={appTitle} />
        <IosCallToAction className="vb-font medium darker">
          {t('login.iosInstallPrompt', { app: appTitle })}
        </IosCallToAction>
      </InstallCardLeft>
      <IosInstallButton
        className="vb-font w700"
        onClick={installApp}
      >
        <Icon
          type={IconTypes.IosInstall}
          color={IconColor.fontBlack}
          size={IconSize.small}
        />
      </IosInstallButton>
    </InstallCard>
  )
}

const IosImageIcon = styled.img`
 width: 60px;
 height: 50px;
`

const InstallCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  gap: 12px;
  min-width: 0;
`

const InstallCardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`

const AppIconWrapper = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
`

const AppIconImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const InstallCardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const AppName = styled.span`
  color: var(--text-decimary);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const AppTagline = styled.span`
  color: var(--text-quaternary);
  font-size: 11px;
  font-weight: 400;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const InstallButton = styled.button`
  border: none;
  color: #ffffff;
  background: var(--button-primary-color);
  font-size: 13px;
  font-weight: 600;
  padding: 8px 18px;
  border-radius: 20px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
`
const IosInstallButton = styled.button`
  border: none;
  color: red;
  background-color: transparent;
  text-decoration: none;
  font-size: var(--font-size-normal);
  cursor: pointer;
`

const IosCallToAction = styled.p`
  align-content: center;
  text-align: left;
`

const ButtonWrapper = styled.button`
  margin-bottom: 50px;
  border: none;
  border-radius: 12px;
  color: var(--font-color-primary);
  background-color: #F4F5F8;
  text-decoration: none;
  font-size: var(--font-size-normal);

  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 6px, rgba(0, 0, 0, 0.1) 0px -1px 6px;
  padding: 8px 0px;

`